<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="创建人编码" prop="creator">
        <el-input v-model="form.creator" placeholder="请输入创建人编码" v-trim/>
      </el-form-item>
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker v-model="form.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="更新人编码" prop="editor">
        <el-input v-model="form.editor" placeholder="请输入更新人编码" v-trim/>
      </el-form-item>
      <el-form-item label="更新时间" prop="editDate">
        <el-date-picker v-model="form.editDate" value-format="yyyy-MM-dd" placeholder="请输入更新时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="是否删除0否 1是" prop="isdeleted">
        <el-input v-model="form.isdeleted" placeholder="请输入是否删除0否 1是" v-trim/>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" placeholder="请输入备注" v-trim/>
      </el-form-item>
      <el-form-item label="商品编码（关联goods表）" prop="goodsId">
        <el-input v-model="form.goodsId" placeholder="请输入商品编码（关联goods表）" v-trim/>
      </el-form-item>
      <el-form-item label="SKU编码（关联sku表）" prop="skuId">
        <el-input v-model="form.skuId" placeholder="请输入SKU编码（关联sku表）" v-trim/>
      </el-form-item>
      <el-form-item label="sku组合名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入sku组合名称" v-trim/>
      </el-form-item>
      <el-form-item label="sku图片" prop="imgurl">
        <el-input v-model="form.imgurl" placeholder="请输入sku图片" v-trim/>
      </el-form-item>
      <el-form-item label="展示价格" prop="showPrice">
        <el-input v-model="form.showPrice" placeholder="请输入展示价格" v-trim/>
      </el-form-item>
      <el-form-item label="销售价格（元/咖豆）" prop="price">
        <el-input v-model="form.price" placeholder="请输入销售价格（元/咖豆）" v-trim/>
      </el-form-item>
      <el-form-item label="库存量" prop="stock">
        <el-input v-model="form.stock" placeholder="请输入库存量" v-trim/>
      </el-form-item>
      <el-form-item label="商品重量(kg)" prop="weight">
        <el-input v-model="form.weight" placeholder="请输入商品重量(kg)" v-trim/>
      </el-form-item>
      <el-form-item label="状态0上架 1下架" prop="status">
        <el-input v-model="form.status" placeholder="请输入状态0上架 1下架" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaGoodsSkuWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        remark: '',
        goodsId: '',
        skuId: '',
        name: '',
        imgurl: '',
        showPrice: '',
        price: '',
        stock: '',
        weight: '',
        status: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/goodsSku',
      'field.id': 'id'
    })
  }
}
</script>
